// Console helpers for development and testing
import { clearHolidayCache, clearAllHolidayCache } from '@/lib/scheduling/holidays';

// Add global functions to window for easy console access
declare global {
  interface Window {
    clearHolidayCache: typeof clearHolidayCache;
    clearAllHolidayCache: typeof clearAllHolidayCache;
  }
}

// Add functions to window object for console access
if (typeof window !== 'undefined') {
  window.clearHolidayCache = clearHolidayCache;
  window.clearAllHolidayCache = clearAllHolidayCache;
}

export { clearHolidayCache, clearAllHolidayCache };